/**
 * Price inside a CTA label. The slot keeps its width (in `ch`, so it scales with the button's
 * font size) while pricing loads, so the button never resizes when the value arrives.
 */
export function PriceText({
  value,
  className = "",
}: {
  value?: string;
  className?: string;
}) {
  return (
    <span
      className={`inline-block text-center tabular-nums transition-opacity duration-200 ${
        value ? "opacity-100" : "opacity-0"
      } ${className}`}
    >
      {value ?? "\u00A0"}
    </span>
  );
}
